
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { debounce } from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import { getBase64 } from '@zero-org/utils'

import { isEmpty } from '@/utils/helpers'
import * as Common from '@/api/common'
import Bus from '@/utils/bus'
import { ChatType } from '@/utils/const'
import { ChatModule } from '@/store/modules/chat'

import SearchPopover from '@/components/search-popover.vue'
import VoiceRecorder from '@/components/voice-recorder.vue'

@Component({
  components: {
    SearchPopover,
    VoiceRecorder
  }
})
export default class PageFooter extends Vue {
  @Prop()
  userId!: any

  @Prop()
  channelId!: any

  @Prop()
  inited!: boolean

  ChatType = ChatType

  maxlength = 500

  // 是否是语音输入类型
  isVoice = false
  // 联想搜索内容
  searchContent = ''
  // 存放联想列表
  searchList: any = []

  selectionStart = 0
  insertContent = ''
  initFlag = false

  onChange = debounce(this.remoteSearch, 200)
  isEmpty = isEmpty

  get placeholder () {
    const text: any = this.$t('inputQA')
    return text
  }

  get disabled () {
    const searchContent = this.searchContent.trim()
    return isEmpty(searchContent)
  }

  get showEmoji () {
    return window.config.showEmoji
  }

  get chatType() {
    return ChatModule.chatType
  }

  @Watch('searchContent')
  onSearchContentChange (val: string) {
    if (isEmpty(val)) {
      this.searchList = []
    }
  }
  mounted() {
    Bus.$on('insertEmoji', (emojiText: string) => {
      const input = this.$refs.input
      if (input) {
        if (this.selectionStart) {
          this.selectionStart = this.selectionStart + this.insertContent.length
          const newContent = `${this.searchContent.substring(0, this.selectionStart)}${emojiText}${this.searchContent.substring(this.selectionStart)}`
          this.searchContent = newContent

          this.insertContent = emojiText

          const index = this.selectionStart + emojiText.length;
          (input as HTMLInputElement).setSelectionRange(index, index);
        } else {
          this.searchContent = this.searchContent + emojiText
        }
      }
    })
  }

  beforeDestroy() {
    Bus.$off('insertEmoji')
  }

  onFileChange() {
    this.initFlag = false
  }

  transformType(base64: any) {
    const promise = new Promise((resolve, reject) => {
      const img = new Image()
      img.src = base64
      img.onload = () => {
        const canvas = document.createElement('canvas')
        canvas.width = img.width
        canvas.height = img.height

        const ctx: any = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0)

        resolve(canvas.toDataURL('image/jpeg'))
      }
    })

    return promise
  }

  beforeUpload(file: File, fileList: File[]) {
    if (!this.initFlag) {
      this.initFlag = true

      for (let i = 0, j = fileList.length; i < j; i++) {
        const _file = fileList[0]
        const type = _file.type
        if (!type.startsWith('image/')) {
          this.$message.error('请上传图片！')
          return false
        }

        const size = _file.size
        if (size > 1024 * 1024 * 2) {
          this.$message.error(`'${_file.name}'大小不能大于2M`)
          return false
        }
      }
      
      fileList.forEach(obj => {
        let oldBase64 = ''
        getBase64(obj).then(base64 => {
          oldBase64 = base64
          return this.transformType(base64)
        }).then(_base64 => {
          this.$emit('sendImg', oldBase64, _base64)
        })
      })

      return false
    }

    // 
    return false
  }

  remoteSearch (e: any) {
    let value = e.target.value
    value = value.trim()
    // 清空数据
    this.searchList = []

    if (!isEmpty(value)) {
      const params = {
        inputText: value,
        userId: this.userId,
        channel: '1',
        channelId: this.channelId
      }
      Common.remoteSearch(params).then((res: any) => {
        const searchList = (res || []).filter((obj: any) => {
          return obj.knowledgeName !== 'null'
        }).splice(0, 6).map((obj: any) => {
          obj.uuid = uuidv4()
          return obj
        })
        if (!isEmpty(this.searchContent)) {
          this.searchList = searchList
        }
      }).catch((err: any) => {
        this.searchList = []
      })
    }
  }

  handleKeyDown(e: any) {
    if (e.keyCode === 13) {
      e.preventDefault()
      this.sendQuestion()
    }
  }

  onSelect (obj: any) {
    this.$emit('select', obj.knowledgeName)
  }

  sendQuestion () {
    const searchContent = this.searchContent.trim()
    if (!isEmpty(searchContent)) {
      this.$emit('select', searchContent)
    }
  }

  showVoice() {
    this.searchContent = ''
    this.isVoice = !this.isVoice
  }

  sendVoice(obj: any) {
    this.$emit('sendVoice', obj)
  }

  handleFocus(e: Event) {
    this.insertContent = ''

    const target: any = e.target
    const selectionStart = target.selectionStart
    this.selectionStart = selectionStart
  }

  handleBlur(e: Event) {
    const target: any = e.target
    const selectionStart = target.selectionStart
    this.selectionStart = selectionStart
  }

  clickOutside() {
    this.searchList = []
  }

  quit() {
    this.$emit('end')
  }
}
